.cardItem {
	margin-bottom: 10px;

	.active {
		color: #7fb02f;
		font-weight: 500;
	}

	.cardBody {
		max-height: 0;
		overflow: hidden;
		transition: max-height 0.3s ease-out;

		.bodyContent {
			padding: inherit;

			.tableTh {
				border: none;
				background-color: #7fb02f;
				color: white;
				font-weight: 400;
			}

			.tableTd {
				font-size: 13px;

				&.number {
					text-align: right;
				}
			}
		}

		&.show {
			max-height: none;
			min-height: 60px;
		}
	}
}
